module.exports = __webpack_public_path__ + "images/b37d574d7f11c04f9356b983c6be32dc.png";